import { HubConnection } from '@microsoft/signalr';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { SendWebsocketMessage } from '../../../utils/websocketHelper';

export interface SendMessageThunkArg {
    connection: HubConnection;
    messageText: string;
    roomId: number;
    attachmentsIds: Array<number>;
}

export const sendDirectRoomMessage = createAsyncThunk(
    'directMessages/send',
    async (arg: SendMessageThunkArg) => {
        let chatMessage = {
            roomId: arg.roomId,
            htmlContent: arg.messageText,
            attachmentsIds: arg.attachmentsIds,
        };
        await SendWebsocketMessage(
            arg.connection,
            'DM_SendMessage',
            chatMessage
        );
    }
);
